export enum Languages {
  POLISH = 'pl',
  CZECH = 'cs',
  SLOVAK = 'sk',
  HUNGARIAN = 'hu',
  ENGLISH = 'en'
}
